import { RouteConfig } from 'vue-router'
import {requireAuth} from '../auth'
import { templateLibraryAdminRoutes } from '../constants/agency/'

const TemplateLibraryAdmin = () =>
  import(
    /* webpackChunkName: "template-library-admin" */ '@/pmd/pages/template_library/TemplateLibraryAdmin.vue'
  )

export const templateLibraryAdmin:RouteConfig[] = [
  {
    path: '/template-library-admin',
    name: templateLibraryAdminRoutes.default,
    component: TemplateLibraryAdmin,
    beforeEnter: requireAuth,
  },
]
